import { Component, OnInit } from '@angular/core';

import { MembershipService } from '@app/core/membership.service';
import { GraphNavigationService } from '@app/registration/graph/graph-navigation.service';
import { LoadingSpinnerComponent } from '@app/shared/loading-spinner/loading-spinner.component';

import { NavbarHeaderComponent } from '../../shared/navbar-header/navbar-header.component';

@Component({
  selector: 'om-trial-video-visit-onboarding',
  templateUrl: './trial-video-visit-onboarding.component.html',
  standalone: true,
  imports: [NavbarHeaderComponent, LoadingSpinnerComponent],
})
export class TrialVideoVisitOnboardingComponent implements OnInit {
  constructor(private graphNavigationService: GraphNavigationService, private membershipService: MembershipService) {}

  ngOnInit(): void {
    this.graphNavigationService.navigate();
  }
}
